// @ts-nocheck

import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import throttle from 'lodash/throttle';
import { InView } from 'react-intersection-observer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { yieldCallback } from '@zillow/yield-callback';
import { anchorOffset } from 'app/shared/styles/_mixins';
import SafeDeferredRender, { RenderMode } from 'app/shared/modules/SafeDeferredRender';

import appUtils from 'app/shared/utils/appUtils';
import perfUtils from 'app/shared/utils/perfUtils';
import { getModalFromQuery, getWebviewModalFromQuery } from 'app/shared/utils/modalUtils';
import trackingUtils from 'app/shared/utils/trackingUtils';
import { getScheduledTour } from 'app/shared/utils/listingUtils';
import UserItemActions from 'app/shared/flux/actions/UserItemActions';
import ListingEngineActions from '../../../flux/actions/ListingEngineActions';

import { trackListingView } from 'app/client/tracking';
import constants from 'app/shared/constants/ConstantsBundle';
import { DEFAULT as DEFAULT_FILTER } from 'app/shared/models/Filter';
import type { RootReduxState } from 'app/shared/flux/reducers';

// Required Components
import BreadcrumbNav from 'app/shared/modules/BreadcrumbNav';
import BrokerInfoTop from 'app/shared/modules/hdp/BrokerInfo/BrokerInfoTop';
import ChatButton from 'app/shared/modules/hdp/ChatButton';
import ContactButtonV2 from 'app/shared/modules/hdp/ContactButtonV2';

import Container from 'app/shared/core/Container';
import ExpiredListingHeader from 'app/shared/modules/hdp/ExpiredListingHeader';
import ExpiredRecommendations from 'app/shared/modules/hdp/ExpiredRecommendations';
import FaqSection from 'app/shared/modules/FaqSection/component';
import Footer from 'app/shared/modules/Footer';
import HdpAmenitySection from 'app/shared/modules/hdp/HdpAmenitySection';
import HdpDescription from 'app/shared/modules/hdp/HdpDescription';
import HdpDescriptionRoomForRent from 'app/shared/modules/hdp/HdpDescriptionRoomForRent';
import HdpHighlights from 'app/shared/modules/hdp/HdpHighlights';
import HdpLegalInfo from 'app/shared/modules/hdp/HdpLegalInfo';
import HdpOpenHouseText from 'app/shared/modules/hdp/HdpOpenHouseText';
import HdpPhotoGalleryV2 from 'app/shared/modules/hdp/galleryV2/HdpPhotoGalleryV2';
import HdpPpcLink from 'app/shared/modules/hdp/HdpPpcLink';
import HdpSatelliteWrapper from 'app/shared/modules/satellite/HdpSatelliteWrapper';
import HdpSchools from 'app/shared/modules/hdp/HdpSchools';
import HdpTextSection from 'app/shared/modules/hdp/HdpTextSection';
import LinkToBuilding from 'app/shared/modules/hdp/LinkToBuilding';
import ListingHiddenNotification from 'app/shared/modules/hdp/ListingHiddenNotification';
import ListingNavBar from 'app/shared/modules/hdp/ListingNavBar';
import ListingNavBarMenu from 'app/shared/modules/hdp/ListingNavBarMenu';
import Local from 'app/shared/modules/hdp/Local';
import Popularity from 'app/shared/modules/hdp/Popularity';
import PortfolioProperties from 'app/shared/modules/hdp/PortfolioProperties';
import MostPopularListings from 'app/shared/modules/hdp/MostPopularListings';
import PetFriendlyListings from 'app/shared/modules/hdp/PetFriendlyListings';
import RecentlyViewed from 'app/shared/modules/hdp/RecentlyViewed';
import RepHdpLink from 'app/shared/modules/hdp/RepHdpLink';
import Row from 'app/shared/core/Row';
import BookTourNowButton from 'app/shared/modules/hdp/BookTourNowButton';
import TourStatusModule from 'app/shared/modules/hdp/InstantTour/components/TourStatusModule';
import SeoFooter from 'app/shared/modules/SeoFooter';
import SpecialOffers from 'app/shared/modules/hdp/SpecialOffers';

// Dependant Components
import ActionPopupWrapper from 'app/shared/modules/popups/ActionPopupWrapper';
import { withModal } from './withModal';
import Ad from 'app/shared/modules/Ad';
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import HdpForm from 'app/shared/modules/hdp/HdpForm';
import HdpFullDetailModalWrapper from 'app/shared/modules/hdp/HdpFdp/HdpFullDetailModalWrapper';
import MultiModelsGroup from 'app/shared/modules/hdp/MultiModelsGroup';
import PetPolicy from 'app/shared/modules/hdp/PetPolicy';
import SimilarListingsContainer from 'app/shared/modules/hdp/SimilarListingsContainer';
import SurroundingStats from 'app/shared/modules/hdp/SurroundingStats';
import WaitlistNotice from 'app/shared/modules/hdp/WaitlistNotice';
import ZillowApplicationsButton from 'app/shared/modules/hdp/ZillowApplicationsButton';
import ZrmUpsellCarousel from 'app/shared/modules/ZrmUpsellCarousel';
import { getFaqSchemaTemplate } from 'app/shared/modules/FaqSection/controller';
import HdpSummary from 'app/shared/modules/hdp/HdpSummary';
import BrokerListedBy from '../BrokerInfo/BrokerListedBy';
import dateUtils from 'app/shared/utils/dateUtils';
import { StyledButtonsSectionContainer, StyledHdpContainer, StyledTourStatusModuleContainer } from './Hdp.styles';
import {
  emitTrackHdpSimilarListingClickEvent,
  emitTrackHideHomeFromHdpEvent,
  emitTrackUnhideHomeFromHdpEvent,
} from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import { emitTrackRequestContactStartEvent } from 'app/shared/models/Clickstream/ContactClickstreamEvents';

const AnchorOffset = styled.a`
  ${anchorOffset}
`;
class Hdp extends React.Component {
  static propTypes = {
    clientLoaded: PropTypes.bool,
    conversations: PropTypes.object,
    currentPathname: PropTypes.string,
    device: PropTypes.object,
    dispatch: PropTypes.func,
    filter: PropTypes.object,
    gamAttributes: PropTypes.object,
    indexInList: PropTypes.number,
    isClientLoadedPage: PropTypes.bool,
    isHdpExp: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    isMobile: PropTypes.bool,
    isRep: PropTypes.bool,
    listing: PropTypes.object,
    listings: PropTypes.array,
    location: PropTypes.object,
    modal: PropTypes.object,
    portfolioListings: PropTypes.array,
    scheduledToursForUser: PropTypes.array,
    shouldShowAd: PropTypes.bool,
    showModalOnLoad: PropTypes.oneOf(['InstantTour', 'CostsAndFees', 'Contact', null]),
    showMultiModels: PropTypes.bool,
    sidebarId: PropTypes.string,
    similarListings: PropTypes.array,
    webviewModal: PropTypes.string,
  };

  static defaultProps = {
    clientLoaded: false,
    conversations: {},
    currentPathname: '',
    device: {},
    filter: DEFAULT_FILTER,
    gamAttributes: {},
    indexInList: -1,
    isClientLoadedPage: false,
    isHdpExp: false,
    isLoggedIn: false,
    isMobile: false,
    isRep: false,
    listing: {},
    listings: [],
    location: { query: {} },
    modal: null,
    portfolioListings: [],
    scheduledToursForUser: [],
    shouldShowAd: false,
    showModalOnLoad: null,
    showMultiModels: false,
    sidebarId: '',
    similarListings: [],
    webviewModal: null,
  };

  constructor(props) {
    super(props);

    let initialVisibleActionPopup = null;
    if (props.showModalOnLoad === 'Contact') {
      initialVisibleActionPopup = 'contact';
    } else if (props.showModalOnLoad === 'CostsAndFees') {
      initialVisibleActionPopup = 'costsAndFees';
    } else if (props.showModalOnLoad === 'InstantTour') {
      initialVisibleActionPopup = 'BookTourNowButton';
    }

    this.state = {
      contactButtonClass: '',
      isNavBarMenuOpen: false,
      activeFullDetailPage: null,
      shouldShowHideNotification: false,
      visibleActionPopup: initialVisibleActionPopup,
      hasOpenedUrlTriggeredModal: false, // Prevents multiple modal opens from URL params
    };

    this.calculateHeight = throttle(this.calculateHeight.bind(this), 50);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.BookTourNowButtonRef = createRef();
    this.TourStatusModuleRef = createRef();
  }

  componentDidMount() {
    const { listing, isRep, sidebarId, modal, webviewModal, similarListings, isMobile } = this.props;
    const { visibleActionPopup } = this.state;

    this.getScrollPositions();
    this.calculateHeight();

    const isWebviewModalMode = webviewModal !== null;
    if (isWebviewModalMode && visibleActionPopup && !this.state.hasOpenedUrlTriggeredModal) {
      if (['contact', 'contactTourStatusModule'].includes(visibleActionPopup) && modal) {
        this.setState({ hasOpenedUrlTriggeredModal: true });
        modal.openModal({
          type: 'contact',
          props: {
            listing,
            similarListings,
            isPopup: true,
          },
          onClose: () => {
            if (isMobile) {
              appUtils.restoreScrollPosition();
            }
          },
        });
        return;
      }

      if (visibleActionPopup === 'costsAndFees' && modal) {
        this.setState({ hasOpenedUrlTriggeredModal: true });
        modal.openModal({
          type: 'costsAndFees',
          props: {
            isWebview: true,
          },
          onClose: () => {
            if (isMobile) {
              appUtils.restoreScrollPosition();
            }
          },
        });
        return;
      }
    }

    if (listing && listing.active) {
      window.addEventListener('scroll', this.calculateHeight);

      if (sidebarId) {
        this.SIDEBAR = document.getElementById(sidebarId);
        if (this.SIDEBAR) {
          this.SIDEBAR.addEventListener('scroll', this.calculateHeight);
        }
      }
    }

    perfUtils.endMarker('HdpNavBackClick');
    perfUtils.endMarker('HdpNavBackClick_OutsideList');
    perfUtils.endMarker('HdpNavBackClick');
    perfUtils.endMarker('HdpNavForwardClick');
    perfUtils.endMarker('ListingWrapperClick');
    perfUtils.endMarker('ListingCardV3Click');
    perfUtils.endMarker('MapMarkerClick');
    perfUtils.endMarker('SimilarListingsClick');
    trackListingView(listing);
    trackingUtils.goog.appendScript();

    if (isRep) {
      window.addEventListener('keydown', this.handleKeyDown);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showModalOnLoad === 'InstantTour' || prevProps.showModalOnLoad === 'CostsAndFees') {
      return;
    }

    if (prevProps.device && this.props.device) {
      if (prevProps.device.screenWidth !== this.props.device.screenWidth) {
        // these HTML elements will shift with screen size
        this.getScrollPositions();
      }
    }
  }

  componentWillUnmount() {
    const { dispatch, sidebarId } = this.props;

    if (window.googletag) {
      window.googletag.cmd.push(() => {
        if (window.googletag.pubads && window.googletag.pubads() && window.googletag.pubads().clear) {
          window.googletag.pubads().clear();
        }
      });
    }

    if (sidebarId) {
      document.getElementById(this.props.sidebarId).removeEventListener('scroll', this.calculateHeight);
    }

    trackingUtils.removeElementById('google-ad-services');
    window.removeEventListener('scroll', this.calculateHeight);
    window.removeEventListener('keydown', this.handleKeyDown);

    // Need to clear instant tour form data when HDP listing is unmounted.
    dispatch(ListingEngineActions.hpTours.clearInstantTourForm());
  }

  getScrollPositions = () => {
    const { sidebarId } = this.props;
    if (!this.SIDEBAR && sidebarId) {
      this.SIDEBAR = document.getElementById(sidebarId) || {};
    }
    const contactButtonId = 'ContactButtonV2Sticky';
    this.CONTACT_BUTTON_OFFSET_TOP = document.getElementById(contactButtonId)?.offsetTop ?? 0;
    this.CONTACT_FORM_OFFSET_TOP = document.getElementById('HdpForm')?.offsetTop ?? 0;
  };

  calculateHeight = () => {
    const { contactButtonClass } = this.state;
    const scrollingElement = document.scrollingElement || {};
    const scrollTop = Math.max(this.SIDEBAR.scrollTop, scrollingElement.scrollTop);
    const additionalOffset = 21;

    let newContactButtonClass = contactButtonClass;

    if (scrollTop <= this.CONTACT_BUTTON_OFFSET_TOP + additionalOffset) {
      if (contactButtonClass !== '') {
        newContactButtonClass = '';
      }
    } else if (
      scrollTop > this.CONTACT_BUTTON_OFFSET_TOP + additionalOffset &&
      scrollTop <= this.CONTACT_FORM_OFFSET_TOP
    ) {
      if (contactButtonClass !== 'compact') {
        newContactButtonClass = 'compact';
      }
    } else if (scrollTop > this.CONTACT_FORM_OFFSET_TOP) {
      if (contactButtonClass !== 'flat') {
        newContactButtonClass = 'flat';
      }
    }

    if (newContactButtonClass !== contactButtonClass) {
      this.setState({ contactButtonClass: newContactButtonClass });
    }
  };

  handlePositionChange = () => {
    /**
     * If a user expands any section on the hdp, recalculate
     * this.CONTACT_FORM_OFFSET_TOP for the contact button animation
     */
    this.getScrollPositions();
  };

  handleActionPopup = yieldCallback((popupComponentName) => {
    const { modal, listing, similarListings, isMobile } = this.props;

    // Use modal manager for contact-related modals
    if (popupComponentName === 'contact' || popupComponentName === 'contactTourStatusModule') {
      if (modal) {
        if (isMobile) {
          appUtils.saveScrollPosition();
        }

        modal.openModal({
          type: 'contact',
          props: {
            listing,
            similarListings,
            isPopup: true,
          },
          onClose: () => {
            if (isMobile) {
              appUtils.restoreScrollPosition();
            }
            this.refocusElementBeforePopup(popupComponentName);
          },
        });
        return;
      }
    }

    // Fallback to legacy popup system for non-contact modals
    this.setState({ visibleActionPopup: popupComponentName });
  });

  handleKeyDown(event) {
    const { listing } = this.props;
    if (event.ctrlKey && event.key === 'L') {
      window.open(constants.REP_HDP_URI + listing.aliasEncoded, '_blank');
    }
  }

  handleSetFullDetailPage = ({ fdpName, params = {} }) => {
    const { isMobile } = this.props;

    if (isMobile) {
      appUtils.saveScrollPosition();
    }

    this.setState({ activeFullDetailPage: { name: fdpName, params } });
  };

  handleHideFullDetailModal = yieldCallback(() => {
    const { isMobile } = this.props;
    this.setState({ activeFullDetailPage: null }, () => {
      if (isMobile) {
        appUtils.restoreScrollPosition();
      }
    });
  });

  handleContactCTAClick = yieldCallback(() => {
    const { isMobile, modal, listing, similarListings } = this.props;

    if (isMobile) {
      appUtils.saveScrollPosition();
    }

    // Use the new modal manager for contact modals
    if (modal) {
      modal.openModal({
        type: 'contact',
        props: {
          listing,
          similarListings,
          isPopup: true,
        },
        onClose: () => {
          if (isMobile) {
            appUtils.restoreScrollPosition();
          }
        },
      });
    } else {
      // Fallback to legacy popup system
      this.setState({ visibleActionPopup: 'contact' });
    }

    emitTrackRequestContactStartEvent({
      listing: listing,
      triggerLocation: 'home_details',
      triggerObject: 'home_details_component|summary',
    });
  });

  refocusElementBeforePopup = (popupComponentName) => {
    if (popupComponentName === 'BookTourNowButton') {
      this.BookTourNowButtonRef.current?.focus();
    }
    if (popupComponentName === 'contactTourStatusModule') {
      this.TourStatusModuleRef.current?.focusContactPropertyButton();
    }
    if (popupComponentName === 'ModifyTourCTA') {
      this.TourStatusModuleRef.current?.focusRescheduleOrBookAnotherButton();
    }
  };

  handleHideActionPopup = yieldCallback(() => {
    const { isMobile } = this.props;
    const popupComponentName = this.state.visibleActionPopup;

    if (popupComponentName === 'BookTourNowButton' || popupComponentName === 'ModifyTourCTA') {
      this.getScrollPositions();
    }

    this.setState({ visibleActionPopup: null }, () => {
      if (isMobile) {
        appUtils.restoreScrollPosition();
      }
      this.refocusElementBeforePopup(popupComponentName);
    });
  });

  yieldToggleNavBarMenu = yieldCallback(() => {
    const { isNavBarMenuOpen } = this.state;

    this.setState({
      isNavBarMenuOpen: !isNavBarMenuOpen,
    });
  });

  handleNavBarMenuToggle = () => {
    this.yieldToggleNavBarMenu();
  };

  handleNavBarMenuActionClick = yieldCallback((componentName) => {
    this.handleActionPopup(componentName);
    this.handleNavBarMenuToggle();
  });

  handleToggleHideListing = yieldCallback(() => {
    const { dispatch, listing, isLoggedIn } = this.props;
    const isListingHidden = listing.userItemTypes && includes(listing.userItemTypes, 'hidden');
    this.handleNavBarMenuToggle();
    dispatch(UserItemActions.toggleUserItem('hidden', listing));
    if (!isLoggedIn) {
      return null;
    }
    if (!isListingHidden) {
      this.setState({ shouldShowHideNotification: true });
      this.hideNotificationTimeout = setTimeout(this.handleHideHideNotification, 3000);

      emitTrackHideHomeFromHdpEvent();
    } else {
      emitTrackUnhideHomeFromHdpEvent();
    }
  });

  handleUndoHideListing = () => {
    const { dispatch, listing } = this.props;
    this.handleHideHideNotification();
    dispatch(UserItemActions.toggleUserItem('hidden', listing));
  };

  handleHideHideNotification = () => {
    clearTimeout(this.hideNotificationTimeout);
    this.setState({ shouldShowHideNotification: false });
  };

  handleHdpToHdpOutsideOfList = () => {
    const { dispatch, currentPathname } = this.props;

    dispatch(ListingEngineActions.setCurrentListingOutsideOfList(true, currentPathname));
  };

  handleRecommendedListingClick = () => {
    this.handleHdpToHdpOutsideOfList();
  };

  handleExpiredRecommendationClick = () => {
    this.handleHdpToHdpOutsideOfList();
  };

  handlePropertyPortfolioListingClick = () => {
    this.handleHdpToHdpOutsideOfList();
  };

  handleRecentlyViewedClick = () => {
    this.handleHdpToHdpOutsideOfList();
  };

  handleSimilarListingsClick = () => {
    perfUtils.setMarker('SimilarListingsClick');
    emitTrackHdpSimilarListingClickEvent();
    this.handleHdpToHdpOutsideOfList();
  };

  getSchemaData = (listing) => {
    return getFaqSchemaTemplate({ data: { listing } });
  };

  render() {
    if (!this.props.listing) {
      return null;
    }

    const {
      clientLoaded,
      conversations,
      device,
      filter,
      gamAttributes,
      indexInList,
      isMobile,
      listing,
      listings,
      location,
      modal,
      portfolioListings,
      scheduledToursForUser,
      shouldShowAd,
      showModalOnLoad,
      showMultiModels,
      similarListings,
    } = this.props;
    const {
      contactButtonClass,
      visibleActionPopup,
      isNavBarMenuOpen,
      shouldShowHideNotification,
      activeFullDetailPage,
    } = this.state;
    const {
      active: isListingActive,
      aliasEncoded,
      broker,
      details,
      history,
      isAllowedToRetain,
      trusted,
      waitlisted,
    } = listing;
    const isListingHidden = listing.userItemTypes && includes(listing.userItemTypes, 'hidden');
    const listOfHdpUrls = listings.map((summary) => summary.uriV2);
    const faqSectionData = trusted && this.getSchemaData(listing);
    const hasConversation = conversations[aliasEncoded];
    const satelliteEnabled = hasConversation ? conversations[aliasEncoded].satelliteEnabled : false;
    const shouldDisplayBrokerInfo = broker?.isBrokerExclusiveListing || broker?.isBrokerListing;
    const { leaseTermsAndUtilitiesShareDescription } = details ?? {};
    const { inPersonProvider, liveVideoProvider, selfGuidedProvider } = details.instantTourProviders ?? {};
    const isInstantTourAvailable = inPersonProvider || liveVideoProvider || selfGuidedProvider;
    const scheduledTour = getScheduledTour(aliasEncoded, scheduledToursForUser);
    const userHasTourForListing = Object.keys(scheduledTour).length > 0;

    // Check if we're in webview modal mode (directly check query params)
    const query = location?.query || {};
    const hasShowModalParam = query.showModal || query.webviewModal;
    const webviewModal = getWebviewModalFromQuery(query);
    const isWebviewModalMode = webviewModal !== null;

    // Early return for showModal=costsandfees to prevent HDP flash during SSR
    if (hasShowModalParam && typeof hasShowModalParam === 'string') {
      const normalizedParam = hasShowModalParam.toLowerCase();
      if (normalizedParam === 'costsandfees') {
        return <div style={{ minHeight: '100vh' }} />;
      }
    }

    if (showModalOnLoad === 'InstantTour') {
      let isRescheduling = false;

      if (userHasTourForListing) {
        const scheduledDateTime = dateUtils.appendTimeISOSubstringIfMissing(scheduledTour.startTime);
        isRescheduling = !dateUtils.isDateInThePast(scheduledDateTime);
      }

      return (
        <ActionPopupWrapper
          componentName={isRescheduling ? 'ModifyTourCTA' : 'BookTourNowButton'}
          onActionPopup={null}
          onHidePopup={null}
        />
      );
    }

    if (showModalOnLoad === 'CostsAndFees') {
      // Return minimal loading state while modal opens in componentDidMount
      return <div style={{ minHeight: '100vh' }} />;
    }

    const showTourStatusModule = userHasTourForListing;
    const showScheduleTourButton = isListingActive && isInstantTourAvailable && !showTourStatusModule;
    const showContactButton = (!hasConversation || !satelliteEnabled) && isListingActive;
    const showApplicationButton =
      isListingActive && ((!showTourStatusModule && !showScheduleTourButton) || !showScheduleTourButton);

    /**
     * Data should be hidden per MLS if the listing is:
     * -- active: false
     * -- isAllowedToRetain: false
     */
    const shouldBeHiddenIfDataCannotBeRetained = isListingActive === false && isAllowedToRetain === false;

    // If we're in webview modal mode, only render the modal
    if (isWebviewModalMode && visibleActionPopup) {
      // Use modal manager for contact modals in webview mode
      if (['contact', 'contactTourStatusModule'].includes(visibleActionPopup) && modal) {
        modal.openModal({
          type: 'contact',
          props: {
            listing,
            similarListings,
            isPopup: true,
          },
          onClose: () => {
            if (isMobile) {
              appUtils.restoreScrollPosition();
            }
          },
        });
        return null;
      }

      return (
        <ActionPopupWrapper
          componentName={visibleActionPopup}
          onActionPopup={this.handleActionPopup}
          onHidePopup={this.handleHideActionPopup}
        />
      );
    }

    return (
      <StyledHdpContainer id="Hdp-container">
        <ListingNavBar
          contactButtonClass={contactButtonClass}
          currentListingIndex={indexInList}
          listOfHdpUrls={listOfHdpUrls}
          listing={listing}
          isMenuOpen={isNavBarMenuOpen}
          onActionClick={this.handleActionPopup}
          onMenuToggle={this.handleNavBarMenuToggle}
          onContactFabClick={this.handleContactCTAClick}
        />
        {isNavBarMenuOpen && (
          <ListingNavBarMenu
            listing={listing}
            isListingHidden={isListingHidden}
            onToggleOpen={this.handleNavBarMenuToggle}
            onActionClick={this.handleNavBarMenuActionClick}
            onToggleHide={this.handleToggleHideListing}
          />
        )}
        {shouldShowHideNotification && (
          <ListingHiddenNotification
            isOpen={this.shouldShowHideNotification}
            onClose={this.handleHideHideNotification}
            onUndo={this.handleUndoHideListing}
          />
        )}
        <Container>
          <BreadcrumbNav variant="baseRental" identifier="top-hdp" />
        </Container>
        <HdpPhotoGalleryV2
          listing={listing}
          key={listing.aliasEncoded}
          onClickContact={() => {
            this.handleActionPopup('contact');
          }}
          onClickOpenFdp={this.handleSetFullDetailPage}
        />
        {activeFullDetailPage && (
          <HdpFullDetailModalWrapper
            componentName={activeFullDetailPage.name}
            componentParams={activeFullDetailPage.params}
            onClickContact={this.handleContactCTAClick}
            onHideModal={this.handleHideFullDetailModal}
          />
        )}
        <div className="Hdp-listing-container" id="Hdp-listing-container">
          {!isListingActive && <ExpiredListingHeader history={history} />}
          {isListingActive && waitlisted && <WaitlistNotice />}
          <ChatButton listing={listing} />
          <LinkToBuilding listing={listing} />
          <HdpSummary listing={listing} />
          {hasConversation && <HdpSatelliteWrapper />}
          {!isListingActive && <ExpiredRecommendations onListingClick={this.handleSimilarListingsClick} />}
          {!isListingActive && <ZrmUpsellCarousel />}
          <StyledButtonsSectionContainer>
            {showTourStatusModule && (
              <StyledTourStatusModuleContainer>
                <TourStatusModule
                  ref={this.TourStatusModuleRef}
                  listing={listing}
                  isRenderedOnHdp
                  onBookAnotherTourClick={() => {
                    this.handleActionPopup('BookTourNowButton');
                  }}
                  onRescheduleTourClick={() => {
                    this.handleActionPopup('ModifyTourCTA');
                  }}
                  onContactPropertyClick={() => {
                    this.handleActionPopup('contactTourStatusModule');
                  }}
                />
              </StyledTourStatusModuleContainer>
            )}
            {showContactButton && (
              <ContactButtonV2
                listing={listing}
                onClick={this.handleContactCTAClick}
                contactButtonOffsetTop={this.CONTACT_BUTTON_OFFSET_TOP}
              />
            )}
            {showApplicationButton && (
              <ZillowApplicationsButton showContactButton={showContactButton} onActionPopup={this.handleActionPopup} />
            )}
            {showScheduleTourButton && (
              <BookTourNowButton
                ref={this.BookTourNowButtonRef}
                onClick={() => {
                  this.handleActionPopup('BookTourNowButton');
                }}
              />
            )}
          </StyledButtonsSectionContainer>
          <SpecialOffers offers={listing.specialOffers} onActionPopup={this.handleActionPopup} />
          {shouldBeHiddenIfDataCannotBeRetained ? null : <HdpHighlights listing={listing} />}
          {showMultiModels && (
            <SafeDeferredRender
              mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
              visibilityOptions={{ rootMargin: '200px' }}
            >
              <InView onChange={this.handlePositionChange}>
                <MultiModelsGroup
                  filter={filter}
                  listing={listing}
                  onActionPopup={this.handleActionPopup}
                  onClickOpenFdp={this.handleSetFullDetailPage}
                />
              </InView>
            </SafeDeferredRender>
          )}
          {shouldBeHiddenIfDataCannotBeRetained ? null : (
            <SafeDeferredRender
              mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
              visibilityOptions={{ rootMargin: '200px' }}
            >
              <>
                {shouldDisplayBrokerInfo && <BrokerInfoTop broker={broker} isListingActive={isListingActive} />}
                <Local listing={listing} />
              </>
            </SafeDeferredRender>
          )}
          <SafeDeferredRender
            mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
            visibilityOptions={{ rootMargin: '200px' }}
          >
            <HdpPpcLink listing={listing} linkText="View more details on property website" ppcLocation="hdp" />
          </SafeDeferredRender>
          {visibleActionPopup && !['contact', 'contactTourStatusModule'].includes(visibleActionPopup) && (
            <ActionPopupWrapper
              componentName={visibleActionPopup}
              onActionPopup={this.handleActionPopup}
              onHidePopup={this.handleHideActionPopup}
            />
          )}
          <SafeDeferredRender
            mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
            visibilityOptions={{ rootMargin: '200px' }}
          >
            <AnchorOffset id="PropertyDetails" />
          </SafeDeferredRender>
          {shouldBeHiddenIfDataCannotBeRetained ? null : (
            <SafeDeferredRender
              mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
              visibilityOptions={{ rootMargin: '200px' }}
            >
              <HdpDescription />
              <HdpDescriptionRoomForRent />
              <HdpAmenitySection listing={listing} screenWidth={device.screenWidth} />
            </SafeDeferredRender>
          )}
          {shouldBeHiddenIfDataCannotBeRetained ? null : (
            <SafeDeferredRender
              mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
              visibilityOptions={{ rootMargin: '200px' }}
            >
              <PetPolicy onPetCtaClick={this.handleContactCTAClick} />
              <Popularity clientLoaded={clientLoaded} handleContactCta={this.handleContactCTAClick} listing={listing} />
              <HdpOpenHouseText listing={listing} />
            </SafeDeferredRender>
          )}
          {shouldBeHiddenIfDataCannotBeRetained ? null : (
            <SafeDeferredRender
              mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
              visibilityOptions={{ rootMargin: '200px' }}
            >
              <>
                <HdpTextSection
                  content={leaseTermsAndUtilitiesShareDescription}
                  header={`Terms at ${
                    listing.address && listing.address.hideStreet ? 'this listing' : listing.displayName
                  }`}
                />
                <HdpTextSection content={details.contactTimes} header={`Office hours at ${listing.displayName}`} />
                {!listing.isApartmentBldg && <SurroundingStats listing={listing} />}
              </>
            </SafeDeferredRender>
          )}
          <SafeDeferredRender
            mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}
            visibilityOptions={{ rootMargin: '200px' }}
          >
            <>
              <HdpSchools listing={listing} hideStreet={listing.address && listing.address.hideStreet} />
              {listing.legalDisclaimer && !isEmpty(listing.legalDisclaimer) && <HdpLegalInfo listing={listing} />}
            </>
          </SafeDeferredRender>
          {isListingActive && (
            <InView onChange={this.handlePositionChange}>
              <div>
                <div id="HdpFormWrapper">
                  <HdpForm
                    onShowSuccessModal={this.handleActionPopup}
                    listing={listing}
                    similarListings={similarListings}
                  />
                </div>
              </div>
            </InView>
          )}
          <SafeDeferredRender mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}>
            <>
              {isListingActive && (
                <SimilarListingsContainer
                  currentListing={listing}
                  similarListings={similarListings}
                  onClick={this.handleSimilarListingsClick}
                />
              )}
              {isListingActive && (
                <PortfolioProperties
                  currentListing={listing}
                  portfolioListings={portfolioListings}
                  onClick={this.handleRecentlyViewedClick}
                  screenWidthForDesktopSRPFilter={device.screenWidthForDesktopSRPFilter}
                />
              )}
              {isListingActive && (
                <MostPopularListings
                  onListingClick={this.handleRecentlyViewedClick}
                  screenWidthForDesktopSRPFilter={device.screenWidthForDesktopSRPFilter}
                />
              )}
              {isListingActive && (
                <PetFriendlyListings
                  onListingClick={this.handleRecentlyViewedClick}
                  screenWidthForDesktopSRPFilter={device.screenWidthForDesktopSRPFilter}
                />
              )}
            </>
          </SafeDeferredRender>
          <SafeDeferredRender mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}>
            <>
              <RecentlyViewed
                onListingClick={this.handleRecentlyViewedClick}
                screenWidthForDesktopSRPFilter={device.screenWidthForDesktopSRPFilter}
              />
              {trusted && faqSectionData && (
                <FaqSection data={faqSectionData.data} wrapper={HdpContentWrapper} {...faqSectionData.props} />
              )}
            </>
          </SafeDeferredRender>
          {shouldShowAd && <Ad gamAttributes={gamAttributes} squareAd />}
          <SafeDeferredRender mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}>
            <RepHdpLink listing={listing} />
            <BrokerListedBy />
          </SafeDeferredRender>
          <SafeDeferredRender mode={RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE}>
            <Container>
              <Row size="md">
                <BreadcrumbNav identifier="bottom-hdp" />
              </Row>
            </Container>
            <SeoFooter />
            <Footer noMarginTop />
          </SafeDeferredRender>
        </div>
      </StyledHdpContainer>
    );
  }
}

const mapStateToProps = (state: RootReduxState) => {
  const isRep = state.user.info.roles.indexOf('rep') > -1;

  return {
    areaType: state.area.area.type,
    clientLoaded: state.app.clientLoaded,
    conversations: state.user.conversations,
    currentPathname: state.location.current.pathname,
    device: state.app.device,
    filter: state.filter,
    indexInList: state.currentListingDetails.indexInList,
    instantTourForm: state.currentListingDetails.instantTourForm,
    isClientLoadedPage: state.app.isClientSideLoadedPage,
    isHdpExp: state.analytics.runningExperiments[constants.HOTPADS_WEB_HDP_AA_TEST]?.isControl === false,
    isLoggedIn: state.user.loggedIn,
    isMobile: state.app.device.screenWidth === 'sm' || state.app.device.screenWidth === 'xs',
    isRep,
    listing: state.currentListingDetails.currentListing,
    listings: state.listings.listingGroups.byCoords,
    location: state.location.ssrEntry,
    portfolioListings: state.listings.listingGroups.portfolio,
    scheduledToursForUser: state.user.scheduledTours,
    showModalOnLoad:
      getWebviewModalFromQuery(state.location.ssrEntry.query) || getModalFromQuery(state.location.ssrEntry.query),
    similarListings: state.fetchListing.similarListings,
  };
};

export default withRouter(connect(mapStateToProps)(withModal(Hdp)));
